import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { myBTLoginTracker } from "@util/helpers";

export type KeywordLimitModalVersion1SubContentProps = {
  //Callback function triggered when the modal is closed.
  onClose: () => void;
};

export default function KeywordLimitModalVersion1SubContent({
  onClose,
}: KeywordLimitModalVersion1SubContentProps): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const userType = OKTAUserInfo?.usertype;

  const isLoggedIn =
    userType === OKTAUserTypeEnum.SUBSCRIBER ||
    userType === OKTAUserTypeEnum.REGISTERED;

  const trackMyBtLogin = () => {
    onClose();
    myBTLoginTracker(isLoggedIn, "edit my keywords");
  };

  return (
    <div className="px-3 md:pb-3">
      <h2 className="my-3 text-center text-3xl font-semibold">
        We are glad that you enjoy myBT
      </h2>

      <p className="px-2 text-center text-gray-850 text-opacity-80">
        You have reached your limit of 30 keywords. subscribe to BT To follow
        new keywords, edit your myBT settings..
      </p>

      <Link
        to={RouteFactory.myAccount}
        className="mx-auto block w-[55%] rounded-full px-5 py-2 text-center text-base font-normal ring-1 ring-black md:w-[45%] md:px-7"
        onClick={trackMyBtLogin}
        reloadDocument
      >
        EDIT MY KEYWORDS
      </Link>
    </div>
  );
}
